(function () {
  'use strict';

  var KEY = 'cp_wishlist';
  var page = document.querySelector('[data-wishlist-page]');
  if (!page) return;

  var grid = page.querySelector('[data-wishlist-grid]');
  var empty = page.querySelector('[data-wishlist-empty]');

  function getItems() {
    try {
      var items = JSON.parse(localStorage.getItem(KEY)) || [];
      return items.map(function (item) { return typeof item === 'object' ? item : { id: item }; });
    } catch (error) { return []; }
  }

  function saveItems(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (error) {}
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    if (Number(cents) === 0) return 'Call for Price';
    var amount = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return 'Rs.' + amount;
  }

  function buildCard(item) {
    var image = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
      : '<span class="wishlist-card__placeholder">&#9825;</span>';
    return '<article class="wishlist-card" data-wishlist-card="' + escapeHtml(item.id) + '">' +
      '<a class="wishlist-card__media" href="' + escapeHtml(item.url || '#') + '">' + image + '</a>' +
      '<div class="wishlist-card__body">' +
        '<h2><a href="' + escapeHtml(item.url || '#') + '">' + escapeHtml(item.title || 'Product') + '</a></h2>' +
        '<strong>' + escapeHtml(item.price || '') + '</strong>' +
        '<div class="wishlist-card__actions"><a class="wishlist-card__view" href="' + escapeHtml(item.url || '#') + '">View product</a><button type="button" data-wishlist-remove="' + escapeHtml(item.id) + '" aria-label="Remove ' + escapeHtml(item.title) + '">Remove</button></div>' +
      '</div>' +
    '</article>';
  }

  function render(items) {
    if (!items) items = getItems().filter(function (item) { return item.id; });
    if (!items.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    grid.innerHTML = items.map(buildCard).join('');
  }

  /* Enrich items that are missing title/image by fetching from Shopify API */
  function enrichAndRender() {
    var items = getItems().filter(function (item) { return item.id; });
    if (!items.length) { render(items); return; }

    var needEnrich = items.filter(function (item) {
      return !item.title || item.title === 'Product' || !item.image;
    });

    if (!needEnrich.length) { render(items); return; }

    /* Show a loading state while fetching */
    grid.innerHTML = '<div style="text-align:center;padding:40px;color:var(--muted,#777);font-size:15px;">Loading your wishlist...</div>';
    empty.hidden = true;

    var pending = needEnrich.length;
    var changed = false;

    needEnrich.forEach(function (item) {
      /* Try to find product handle from stored URL first */
      var handle = '';
      if (item.url && item.url.indexOf('/products/') !== -1) {
        handle = item.url.split('/products/')[1].split('?')[0].split('#')[0];
      }

      var fetchUrl = handle
        ? '/products/' + handle + '.js'
        : '/products.json?limit=250';

      fetch(fetchUrl, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var product = null;
          if (handle) {
            /* Direct product fetch */
            product = data;
          } else {
            /* Search in products list */
            var products = data.products || [];
            for (var i = 0; i < products.length; i++) {
              if (String(products[i].id) === String(item.id)) {
                product = products[i];
                break;
              }
            }
          }

          if (product) {
            changed = true;
            item.title = product.title || item.title;
            item.url = item.url || ('/products/' + product.handle);
            if (product.featured_image) {
              item.image = typeof product.featured_image === 'string'
                ? product.featured_image
                : product.featured_image.src || product.featured_image;
            } else if (product.images && product.images.length) {
              item.image = typeof product.images[0] === 'string'
                ? product.images[0]
                : product.images[0].src || product.images[0];
            }
            if (product.price) {
              item.price = formatMoney(product.price);
            } else if (product.variants && product.variants.length && product.variants[0].price) {
              var p = product.variants[0].price;
              item.price = typeof p === 'number' ? formatMoney(p) : String(p);
            }
          }
        })
        .catch(function () { /* ignore fetch errors */ })
        .finally(function () {
          pending--;
          if (pending <= 0) {
            /* Filter out any items that are still invalid */
            var finalItems = items.filter(function (itm) {
              return itm.title && itm.title !== 'Product' && itm.image;
            });
            if (finalItems.length !== items.length || changed) {
              saveItems(finalItems);
            }
            render(finalItems);
          }
        });
    });
  }

  grid.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-wishlist-remove]');
    if (!remove) return;
    event.preventDefault();
    var id = remove.getAttribute('data-wishlist-remove');
    var items = getItems().filter(function (item) { return String(item.id) !== String(id); });
    saveItems(items);
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: items } }));
    render(items);
  });

  document.addEventListener('wishlist:change', function () { render(); });

  /* Initial load: enrich incomplete items, then render */
  enrichAndRender();
})();
